"use client"

import { useCallback } from "react"
import { useRouter } from "next/navigation"
import { useLoadingStore } from "@/stores/loading-store"

import { requestNavigation } from "@/lib/navigation-guard"
import { useBookId } from "@/hooks/use-book-id"

export function useLoadingRouter({ bookScoped = true }: { bookScoped?: boolean } = {}) {
  const router = useRouter()
  const currentBookId = useBookId()
  const bookId = bookScoped ? currentBookId : undefined
  const setLoading = useLoadingStore((state) => state.setLoading)

  const push = useCallback(
    (href: string) => {
      const routePrefix = bookId ? `/${bookId}` : ""
      const newHref = href.startsWith("/") ? `${routePrefix}${href}` : `${routePrefix}/${href}`
      const targetRoute = newHref.endsWith("?") ? newHref.slice(0, -1) : newHref
      if (!requestNavigation(newHref)) return
      setLoading(true, targetRoute)
      router.push(newHref)
    },
    [router, bookId, setLoading]
  )

  const replace = useCallback(
    (href: string) => {
      if (href.startsWith("?")) {
        if (!requestNavigation(href)) return
        router.replace(href)
      } else {
        const routePrefix = bookId ? `/${bookId}` : ""
        const newHref = href.startsWith("/") ? `${routePrefix}${href}` : `${routePrefix}/${href}`
        const targetRoute = newHref.endsWith("?") ? newHref.slice(0, -1) : newHref
        if (!requestNavigation(newHref)) return
        setLoading(true, targetRoute)
        router.replace(newHref)
      }
    },
    [router, bookId, setLoading]
  )

  return { push, replace }
}
